module.exports = __webpack_public_path__ + "static/img/xiazailuxiang.c049818.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/xiazailuxiang.png
// module id = KCJe
// module chunks = 24